export const SignLink = {
  path: "/sign-link",
  name: "sign-link",
  meta: { title: "电子签认证" },
  component: () =>
    import(
      /* webpackChunkName: "sign-link" */ "@/views/signatures/customer-management/sign-link/index.vue"
    ),
};
